import React from "react";
// import { withStyles } from "@material-ui/core/styles";
// import Snack from "@material-ui/core/SnackbarContent";
// import IconButton from "@material-ui/core/IconButton";
import {
  withStyles,
  SnackbarContent as Snack,
  IconButton
} from "@material-ui/core";

import { Close } from "@material-ui/icons";
import PropTypes from "prop-types";
import cx from "classnames";

import snackbarContentStyle from "../../variables/styles/snackbarContentStyle.jsx";

function SnackbarContent({ ...props }) {
  const { classes, message, count, color, close, icon, onClick } = props;
  var action = [];
  const messageClasses = cx({
    [classes.iconMessage]: icon !== undefined
  });
  if (close !== undefined) {
    action = [
      <IconButton
        className={classes.iconButton}
        key="close"
        aria-label="Close"
        color="inherit"
      >
        <Close className={classes.close} />
      </IconButton>
    ];
  }
  return (
    <Snack
      message={
        <div>
          {icon !== undefined ? <props.icon className={classes.icon} /> : null}
          <span className={messageClasses}>{message}</span>
          {count ? <div className="snack-count">{count}</div> : null}
        </div>
      }
      classes={{
        root: classes.root + " " + classes[color],
        message: classes.message
      }}
      style={props.fullWidth ? {width: '100%'} : null}
      action={action}
      onClick={onClick}
    />
  );
}

SnackbarContent.propTypes = {
  classes: PropTypes.object.isRequired,
  message: PropTypes.node.isRequired,
  color: PropTypes.oneOf(["info", "success", "warning", "danger", "primary"]),
  close: PropTypes.bool,
  icon: PropTypes.func
};

export default withStyles(snackbarContentStyle)(SnackbarContent);
